import React, { useState } from "react";
import Icons from "../../Constants/Icons";
import Colors from "../../Constants/Colors";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CopyToClipboard from "../CopyToClipboard";

function GiftListRender({ session }) {
  const navigate = useNavigate();
  return (
    <div
      onClick={
        () => {}
        // navigate("/ScheduledSessionInfo", { state: { sessionData: session } })
      }
      style={{
        // cursor: "pointer",
        alignSelf: "stretch",
        borderBottom: Colors.darkBorderColor,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "1rem",
        gap: "0.5rem",
      }}
    >
      <div
        style={{
          width: "25%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "0.5rem",
          alignSelf: "stretch",
          wordBreak: "break-word",
        }}
      >
        <div
          style={{
            fontFamily: "Poppins-Regular",
            fontSize: "0.8rem",
            fontWeight: 400,
            color: "#fff",
            position: "relative",
          }}
        >
          {session?._id}
        </div>
        <CopyToClipboard text={session?._id}>
          <img
            style={{ cursor: "pointer" }}
            className="icon_copy"
            alt=""
            src={Icons.ic_copy}
          />
        </CopyToClipboard>
      </div>
      <div
        style={{
          width: "20%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          cursor:"pointer",
          gap: "0.5rem",
        }}
        onClick={(e) => {
          e.stopPropagation();
          navigate("/UserProfile", {
            state: {
              userId: session.userId,
              userShortId: session?.userShortId ?? session.userId,
            },
          });
        }}
      >
        <div style={{}} className="indian-man-smiling-astrologer">
          <img
            style={{
              position: "relative",
              width: "2.63rem",
              height: "2.63rem",
            }}
            alt=""
            src={session?.userImage ?? Icons.ic_default_user}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              position: "relative",

              fontSize: "0.8rem",
              fontWeight: 400,
              fontFamily: "Poppins-Regular",
              color: Colors.white,
            }}
          >
            {session?.userName}
          </div>
        </div>
      </div>
      <div
        style={{
          width: "20%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "0.5rem",
              cursor:"pointer",
        }}
        onClick={(e) => {
          e.stopPropagation();
          navigate("/AstrologerProfile", {
            state: {
              astrologerId: session?.astrologerId,
            },
          });
        }}
      >
        <div style={{}} className="indian-man-smiling-astrologer">
          <img
            style={{
              position: "relative",
              width: "2.63rem",
              height: "2.63rem",
            }}
            alt=""
            src={session?.astrologerImage ?? Icons.ic_default_user}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              position: "relative",
              fontFamily: "Poppins-Regular",
              fontSize: "0.8rem",
              fontWeight: 400,
              color: Colors.white,
            }}
          >
            {session?.astrologerName}
          </div>
          {/* <div
            style={{
              position: "relative",
              fontSize: "0.8rem",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "0.5rem",
              color: Colors.greyColor50,
            }}
          >
            {transactionId}
          </div> */}
        </div>
      </div>
      <div
        style={{
          width: "25%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "0.5rem",
            fontSize: "0.8rem",
            color: Colors.white,
            position: "relative",
            fontWeight: 400,
            fontFamily: "Poppins-Regular",
          }}
        >
          {moment(session.createdAt).format("YYYY-MM-DD")} {","}
          {moment(session.createdAt).format("hh:mm:ss a")}
        </div>
      </div>

      <div
        style={{
          position: "relative",
          fontSize: "0.8rem",
          width: "10%",
          fontWeight: 400,
          fontFamily: "Poppins-Regular",
          color: Colors.white,
          display: "flex",
          alignItems: "center",
        }}
      >
        ₹{session?.giftPrice}
      </div>
    </div>
  );
}

export default GiftListRender;
